import React from 'react';

import styled from 'styled-components';

import { TotemLabel } from 'components/TotemLabel';
import { TotemImage } from 'components/TotemImage';
import { StatusTag } from 'pages/Products/components/StatusTag';
import { ProductArrangementWithProductsFragmentFragment } from 'data/__generated__';

export const ProductsArrangement = ({
    productArrangement,
}: {
    productArrangement: ProductArrangementWithProductsFragmentFragment;
}) => {
    return (
        <Container>
            <TotemLabel>Produits de la gamme</TotemLabel>
            <ProductTabelContainer>
                <ProductsTable>
                    <thead>
                        <tr>
                            <ProductsTableHeaderCell />
                            <ProductsTableHeaderCell>Produit</ProductsTableHeaderCell>
                            <ProductsTableHeaderCell>Est un produit microstore</ProductsTableHeaderCell>
                            <ProductsTableHeaderCell>Statut du produit</ProductsTableHeaderCell>
                            <ProductsTableHeaderCell $isDataCentered>Stock max</ProductsTableHeaderCell>
                        </tr>
                    </thead>
                    <tbody>
                        {productArrangement.productsWithStockMax.map((productWithStockMax) => {
                            const {
                                product: { _id: productId, brand, imageUrl, isMicrostore, name, state, volume },
                                stockMax,
                            } = productWithStockMax;

                            return (
                                <tr key={productId}>
                                    <ProductsTableBodyCell>
                                        <TotemImage src={imageUrl} alt={name} size={50} />
                                    </ProductsTableBodyCell>
                                    <ProductsTableBodyCell>
                                        {name} - {brand} - {volume}
                                    </ProductsTableBodyCell>
                                    <ProductsTableBodyCell>{isMicrostore ? 'Oui' : 'Non'}</ProductsTableBodyCell>
                                    <ProductsTableBodyCell>
                                        <StatusTag state={state} />
                                    </ProductsTableBodyCell>
                                    <ProductsTableBodyCell>{stockMax}</ProductsTableBodyCell>
                                </tr>
                            );
                        })}
                    </tbody>
                </ProductsTable>
            </ProductTabelContainer>
        </Container>
    );
};

const Container = styled.div`
    display: flex;
    flex-direction: column;
    overflow: hidden;
    background-color: ${({ theme }) => theme.cardBackgroundColor};
`;

const ProductTabelContainer = styled.div`
    display: flex;
    flex-direction: column;
    overflow: scroll;
    margin-top: 10px;
    border-radius: ${({ theme }) => theme.borderRadius};
    border: 1px solid ${({ theme }) => theme.lightBorderColor};
`;

const ProductsTable = styled.table`
    border-spacing: 0px;
    position: relative;
`;

const ProductsTableHeaderCell = styled.th<{ $isDataCentered?: boolean }>`
    padding: 10px;
    text-align: ${({ $isDataCentered }) => ($isDataCentered ? 'center' : 'left')};
    position: sticky;
    top: 0;
    background-color: ${({ theme }) => theme.cardBackgroundColor};
`;

const ProductsTableBodyCell = styled.td<{ $isDataCentered?: boolean }>`
    padding: 10px;
    border-top: 1px solid ${({ theme }) => theme.lightBorderColor};
    text-align: ${({ $isDataCentered }) => ($isDataCentered ? 'center' : 'left')};
`;
